import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'
import { startAppUpdates } from './lib/appUpdate.js'

// New deploys are noticed on every foreground and switched to when safe.
startAppUpdates()

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

